import React from 'react';
import { Box } from '@mui/material';
import StatusChip from 'features/feedback/shared/StatusChip';
import VoteButton from 'features/feedback/ideas/VoteButton';
import { IdeaTO } from 'features/feedback/shared/feedback.types';

const IdeaCard: React.FC<{ idea: IdeaTO }> = ({ idea }) => (
  <Box sx={{ display: 'flex', gap: 2, p: '18px 20px', border: '1px solid #E7E7E7', borderRadius: '14px' }}>
    <VoteButton id={idea.id} count={idea.voteCount} voted={idea.votedByMe} />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
        <Box sx={{ fontSize: 16, fontWeight: 700 }}>{idea.title}</Box>
        <StatusChip status={idea.status} />
      </Box>
      <Box sx={{ fontSize: 14, color: '#7A7F88', mb: 0.5 }}>{idea.description}</Box>
      <Box sx={{ fontSize: 12.5, color: '#7A7F88' }}>{idea.authorName}</Box>
    </Box>
  </Box>
);

export default IdeaCard;
